export enum CONTACT_TYPE {
  STUDENT = 'student',
  CLASSROOM = 'classroom',
}
